
export const ERROR_MESSAGES= {
    "ru": {
        "bad-login-or-password":"Неверный пользователь или пароль",
        "login-exists":"Данный логин уже существует",
        "constraint-violation": "Нарушение уникального ключа",
        "bad-pin": "Неверный код регистрации",
        "bad-passwd-reset-code": "Неверный или просроченный код сброса пароля"
    }
}